import QRCode from "qrcode";
import Vue from "vue";
import EscPosImage from '../../plugins/escpos-image';

function iOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

const MAX_BITS = iOS() ? 256 : 20

function errorMessage(error) {
    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось распечатать.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
        type: 'error',
        position: 'bottom-center',
        action: {
            text: 'Ок',
            onClick: (e, toastObject) => {
                toastObject.goAway(0);
            }
        },
    });
}

function int_low_high(inp_number, out_bytes) {
    let number = inp_number
    let outp = [];
    ([...Array(out_bytes)]).forEach(() => {
        outp.push(number % 256)
        number = parseInt(number / 256)
    })
    return outp
}

function wrapText(context, text, x, y, maxWidth, lineHeight) {
    let words = text.split(' ');
    let line = '';

    for (let n = 0; n < words.length; n++) {
        let testLine = line + words[n] + ' ';
        let metrics = context.measureText(testLine);
        let testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
            context.fillText(line, x, y);
            line = words[n] + ' ';
            y += lineHeight;
        } else {
            line = testLine;
        }
    }
    context.fillText(line, x, y);
}

const state = {
    index: 0,
    data: [],
    queue: [],
    printCharacteristic: null,
    width: parseInt(localStorage.getItem('print_width') || 208),
    height: parseInt(localStorage.getItem('print_height') || 104),
    font_size: parseInt(localStorage.getItem('print_font_size') || 17),
    qr_space: parseInt(localStorage.getItem('print_qr_space') || 4),
    qr_width: parseInt(localStorage.getItem('print_qr_width') || 64),
    space_height: parseInt(localStorage.getItem('print_space_height') || 69),
    left_margin: parseInt(localStorage.getItem('print_left_margin') || 0),
    max_bits: parseInt(localStorage.getItem('print_max_bits') || MAX_BITS),
    compress_data: localStorage.getItem('print_compress') === 'true',
    printing_in_progress: false
};

const actions = {
    startPrintData({dispatch, state}, data) {
        if (state.printing_in_progress) {
            state.queue.unshift(data)
        } else {
            dispatch('printData', data)
        }
    },
    endPrintData({dispatch, state}) {

        let next_data = state.queue.pop();

        if (next_data !== undefined) {
            setTimeout(() => {
                dispatch('printData', next_data);
            }, 200)
        } else {
            state.printing_in_progress = false;
        }

    },
    printData({dispatch, state}, {qr_data, lines, description}) {

        state.printing_in_progress = true;

        state.index = 0;

        let canvas = document.createElement('canvas');

        // document.body.appendChild(canvas);

        canvas.width = state.width;
        canvas.height = state.height;

        // Create QR code

        QRCode.toDataURL(qr_data, {width: state.qr_width, margin: 0}, function (err, qr_url) {
            let qr_img = new Image();
            qr_img.src = qr_url;

            // Load QR code

            qr_img.onload = function () {

                // Create image in canvas

                let context = canvas.getContext('2d');

                context.drawImage(qr_img, state.left_margin, state.qr_space / 2);

                context.fillStyle = "black";
                context.font = `bold ${state.font_size}px Arial`;
                let k = 1;
                for (let i in lines) {
                    context.fillText(lines[i], state.qr_width + state.qr_space + state.left_margin, state.font_size * k++);
                }
                context.font = `italic ${state.font_size}px Arial`;
                wrapText(
                    context,
                    description,
                    state.qr_width + state.qr_space + state.left_margin, state.font_size * (lines.length + 1),
                    state.width - (state.qr_width + state.qr_space + state.left_margin), state.font_size
                )

                // Encode image to Bytes array

                // let encoder = new EscPosEncoder();
                // state.data = encoder
                //     .initialize()
                //     .image(canvas, canvas.width, canvas.height)
                //     .raw([0x1B, 0x4A, state.space_height])
                //     // .raw([0x0A])
                //     // .raw([0x1B, 0x32])
                //     .encode();
                //
                // if (state.compress_data) {
                //     state.data[5] = 0x03
                // }

                let image_data = context.getImageData(0, 0, canvas.width, canvas.height)
                image_data.shape = []
                image_data.shape[0] = canvas.width
                image_data.shape[1] = canvas.height
                image_data.shape[2] = 4
                let img = EscPosImage(image_data)
                let raster = img.toRaster().data

                state.data = new Uint8Array(
                    [
                        0x1b, 0x40, // initialize
                        0x1d, 0x76, 0x30, state.compress_data ? 0x03 : 0x0, // image print mode
                        ...int_low_high(canvas.width / 8, 2), // width data
                        ...int_low_high(canvas.height, 2) // height data
                    ].concat(
                        raster // raw image data
                    ).concat(
                        [
                            0x1B, 0x4A, state.space_height // print new line and space height
                        ]
                    )
                )

                // Try connect and send data

                try {

                    if (state.printCharacteristic === null) {

                        navigator.bluetooth.requestDevice(
                            {
                                acceptAllDevices: true, // убрать если есть фильтр, иначе ошибка
                                optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb'],
                                // filters: [{
                                //     services: ['000018f0-0000-1000-8000-00805f9b34fb']
                                // }]
                            }
                        )
                            .then(device => {
                                console.log('> Found ' + device.name);
                                console.log('Connecting to GATT Server...');

                                device.addEventListener('gattserverdisconnected', () => {
                                    state.printCharacteristic = null
                                });

                                return device.gatt.connect();
                            })
                            .then(server => server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb"))
                            .then(service => service.getCharacteristic("00002af1-0000-1000-8000-00805f9b34fb"))
                            .then(characteristic => {

                                state.printCharacteristic = characteristic;

                                console.log('Write start')

                                new Promise((resolve, reject) => {
                                    dispatch('sendNextDataBatch', {resolve, reject})
                                })
                                    .then(() => {
                                        dispatch('endPrintData')
                                        console.log('Write done!')
                                    })
                                    .catch((error) => errorMessage(error))

                            })
                            .catch(
                                (error) => {

                                    state.printing_in_progress = false;
                                    errorMessage(error)

                                }
                            )
                    } else {

                        console.log('Write start')

                        new Promise((resolve, reject) => {
                            dispatch('sendNextDataBatch', {resolve, reject})
                        })
                            .then(() => {
                                dispatch('endPrintData')
                                console.log('Write done!')
                            })
                            .catch((error) => {
                                state.printCharacteristic = null;
                                errorMessage(error);
                            })
                    }

                } catch (e) {

                    state.printing_in_progress = false;
                    errorMessage(e)

                }
            }
        });
    },
    sendNextDataBatch({dispatch, state}, {resolve, reject}) {
        if (state.index + state.max_bits < state.data.length) {
            // Send max_bytes
            state.printCharacteristic.writeValue(state.data.slice(state.index, state.index + state.max_bits)).then(() => {
                state.index += state.max_bits;
                dispatch('sendNextDataBatch', {resolve, reject})
            })
                .catch(error => reject(error));
        } else {
            // Send the last bytes
            if (state.index < state.data.length) {
                state.printCharacteristic.writeValue(state.data.slice(state.index, state.data.length)).then(() => {
                    resolve();
                })
                    .catch(error => reject(error));
            } else {
                resolve();
            }
        }

    },
}

export default {
    namespaced: true,
    state,
    actions,
}